<script>
    const axios = require('axios');
    let dropin;

    import Form from 'form-backend-validation';

    export default {

        props: [
            'environment',
            'defaultSalutation',
            'defaultFirstname',
            'defaultLastname',
            'defaultTitle',
            'identifier',
            'countries'
        ],

        data() {
            return {

                error: false,
                errors: [],
                uuid: this.createUuid(),

                isFree: false,

                isBusy: false,

                invoiceAddress: {},

                addresses: [],

                form: new Form({
                    title: this.defaultTitle,
                    address_id: null,
                    additional: '',
                    salutation: this.defaultSalutation,
                    firstname: this.defaultFirstname,
                    lastname: this.defaultLastname,
                    house_number: '',
                    comment: '',
                    street: '',
                    city: '',
                    zipcode: '',
                    country: 'DE',
                    company: '',
                    vat_id: '',
                    terms: false,
                    newsletter: this.defaultNewsletter,
                    payment_type: null,
                    adyenState: {},
                    browserInfo: {},
                }, {
                    resetOnSuccess: false,
                }),
            }
        },

      computed: {

        countryLabel(){
          return this.countries[this.form.country];
        }

      },

      mounted() {
            axios.get('/profile/address')
                .then(data => {
                    this.addresses = data.data;
                    if (this.addresses.length > 0) {
                        this.invoiceAddress = this.addresses[0];
                    }
                })
                .catch(function(e){if(e.code!=='ECONNABORTED'){throw e;}});

            this.initializeAdyen();
        },

        methods: {

            async initializeAdyen() {
                this.isFree = await this.validateFreeCheckout();

                if (! this.isFree) {
                    const checkout = new AdyenCheckout({
                        originKey: window.adyenOriginKey,
                        locale: "de_DE",
                        environment : this.environment === 'production' ? 'live' : 'test',
                        paymentMethodsResponse: window.adyenResponse
                    });

                    dropin = checkout
                        .create('dropin', {
                            onSubmit: (state, dropin) => {
                                if (! this.isBusy) {
                                    this.validateForm(state);
                                }

                                return false;
                            }
                        })
                        .mount('#dropin-container');
                }
            },

            performFreeCheckout(e) {
                e.preventDefault();

                this.error = false;
                this.errors = [];
                this.form.post('/bestellung')
                    .then(response => {
                        this.addresses = response.addresses;
                        this.form.address_id = response.address_id;

                        this.$refs.spinner.startOnHold();

                        window.location.href = '/bestellung?payload='+encodeURIComponent(this.identifier);
                    })
                    .catch(error => {
                        this.error = true;
                        let errors = this.errors;
                        $.each(error.response.data.errors, function(index, value) {
                            errors.push({field:index,value:value+''});
                        });
                        $('html, body').animate({ scrollTop: ($('[data-id="'+this.uuid+'"]').offset().top-parseInt($("#pageHeader").height()))}, 'slow');
                    });
            },

            performBusinessAccountCheckout(e) {
                e.preventDefault();

                this.error = false;
                this.errors = [];
                
                this.form.payment_type = 'business_account';
                this.form.post('/bestellung')
                    .then(response => {
                        this.addresses = response.addresses;
                        this.form.address_id = response.address_id;

                        this.$refs.spinner.startOnHold();

                        window.location.href = '/bestellung?payload='+encodeURIComponent(this.identifier);
                    })
                    .catch(error => {
                        this.error = true;
                        let errors = this.errors;
                        $.each(error.response.data.errors, function(index, value) {
                            errors.push({field:index,value:value+''});
                        });
                        $('html, body').animate({ scrollTop: ($('[data-id="'+this.uuid+'"]').offset().top-parseInt($("#pageHeader").height()))}, 'slow');
                    });
            },

            async validateFreeCheckout() {
                const data = await axios.get('/api/warenkorb');

                return data.data.total === '0,00';
            },

            validateForm(state) {
                this.error = false;
                this.errors = [];
                this.form.browserInfo = {
                    colorDepth: window.screen.colorDepth,
                    javaEnabled: false,
                    javaScriptEnabled: true,
                    language: navigator.language,
                    screenHeight: window.screen.height,
                    screenWidth: window.screen.width,
                    timeZoneOffset: (new Date()).getTimezoneOffset()
                };
                this.form.adyenState = state.data;

                this.isBusy = true;

                this.form.post('/bestellung')
                    .then(response => {
                        this.addresses = response.addresses;
                        this.form.address_id = response.address_id;

                        this.$refs.spinner.startOnHold();

                        this.isBusy = false;

                        if (response.dropinAction) {
                            const checkout = new AdyenCheckout({
                                originKey: window.adyenOriginKey,
                                locale: "de_DE",
                                environment : this.environment === 'production' ? 'live' : 'test',
                                paymentMethodsResponse: window.adyenResponse
                            });
                            checkout.createFromAction(response.dropinAction).mount('#dropin-container');
                        } else {
                            document.location.href = `/bestellung/authorize/${window.paymentIdentifier}`;
                        }
                    })
                    .catch(error => {
                        this.error = true;
                        let errors = this.errors;
                        $.each(error.response.data.errors, function(index, value) {
                            errors.push({field:index,value:value+''});
                        });
                        $('html, body').animate({ scrollTop: ($('[data-id="'+this.uuid+'"]').offset().top-parseInt($("#pageHeader").height()))}, 'slow');
                        this.isBusy = false;
                    });
            },

            createUuid(){
                let dt = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid;
            }

        },

        watch: {
            invoiceAddress(val) {
                if (val === '') {
                    // Keep payment_type
                    let payment_type = this.form.payment_type;

                    this.form.reset();

                    // Reset payment_type
                    this.form.payment_type = payment_type;
                } else {
                    this.form.populate(val);
                    this.form.address_id = val.id;
                }
            }
        }
    }
</script>